import { useParams } from 'react-router';
import ResponsiveTable from '../../../shared/components/ResponsiveTable';
import {
  FooterColumn,
  SortedColumn,
} from '../../../shared/components/ResponsiveTable/models';
import {
  TableDataProps,
  TotalProductProps,
} from '../../../shared/models/ReportModel';
import CommonColumns from './CommonColumns';
import styles from '../report.module.scss';
import formatCurrency from '../../../shared/utils/formatCurrency';

const getColumns = (dealId: string, reportType: string, isPayByUser: boolean) =>
  [
    ...CommonColumns(dealId, reportType, isPayByUser),
    {
      name: 'Enrolled',
      title: 'Redeemed',
      cell: (cntx: {
        row: { original: { quantityRedeemed: number; quantityTotal: number } };
      }) => <span className="label">{cntx.row.original.quantityRedeemed}</span>,
      width: 5,
    },
    {
      name: 'Completed',
      title: 'Completed',
      cell: (cntx) => (
        <span className="label">
          {cntx.row.original.statusCounts.Completed}
        </span>
      ),
      width: 5,
    },
  ] as SortedColumn[];

const getFooterColumns = (total: TotalProductProps, isPayByUser: boolean) =>
  [
    {
      name: 'Product Name',
      cell: () => <span className={styles.footerCell}>Total</span>,
    },
    {
      name: 'Total Spent',
      cell: () => (
        <span className={styles.footerCell}>{`$${formatCurrency(
          total.totalSpend,
        )}`}</span>
      ),
    },
    !isPayByUser && {
      name: 'Total Quantity',
      cell: () => (
        <span className={styles.footerCell}>{total.quantityTotal}</span>
      ),
    },
    {
      name: 'Available',
      cell: () =>
        isPayByUser ? (
          <span className={styles.footerCell}>&#8734;</span>
        ) : (
          <span className={styles.footerCell}>{total.quantityNotRedeemed}</span>
        ),
    },
    {
      name: 'Enrolled',
      cell: () => (
        <span className={styles.footerCell}>{total.quantityRedeemed}</span>
      ),
    },
    {
      name: 'Completed',
      cell: () => (
        <span className={styles.footerCell}>
          {total.statusCounts?.Completed}
        </span>
      ),
    },
  ].filter(Boolean) as FooterColumn[]; // Removes the conditional Total Quantity when isPayByUser is true

export default function CourseTable({
  reportDeals: { overview },
  reportType,
  total,
  isPayByUser,
}: TableDataProps) {
  const { dealId } = useParams();

  return (
    <ResponsiveTable
      data={overview.courses}
      columns={getColumns(dealId, reportType, isPayByUser)}
      footerColumns={getFooterColumns(total, isPayByUser)}
    />
  );
}
